"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _activeLinkContext = require("./activeLinkContext");
Object.keys(_activeLinkContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _activeLinkContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _activeLinkContext[key];
    }
  });
});
var _activeMenuContext = require("./activeMenuContext");
Object.keys(_activeMenuContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _activeMenuContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _activeMenuContext[key];
    }
  });
});
var _burgerMenuContext = require("./burgerMenuContext");
Object.keys(_burgerMenuContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _burgerMenuContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _burgerMenuContext[key];
    }
  });
});
var _labelsContext = require("./labelsContext");
Object.keys(_labelsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _labelsContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _labelsContext[key];
    }
  });
});
var _searchInputContext = require("./searchInputContext");
Object.keys(_searchInputContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _searchInputContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _searchInputContext[key];
    }
  });
});